module.exports = __webpack_public_path__ + "static/media/data-wave.8f63ad45.svg";